import i18n from '@dms/i18n';

import {VehicleForm as VFKit} from '../VehicleForm';

export function WltpElectricConsumptionGroup() {
  const ELECTRIC_METRIC_SUFFIX = i18n.t('general.metric.kwh100km');
  return (
    <>
      <VFKit.SimpleNumericField
        decimalPlaces={2}
        forceDecimalPlaces
        name="fuelConsumptionWltpCombinedKwh"
        suffix={ELECTRIC_METRIC_SUFFIX}
      />
      <VFKit.SimpleNumericField
        decimalPlaces={2}
        forceDecimalPlaces
        name="fuelConsumptionWltpCityCenterKwh"
        suffix={ELECTRIC_METRIC_SUFFIX}
      />
      <VFKit.SimpleNumericField
        decimalPlaces={2}
        forceDecimalPlaces
        name="fuelConsumptionWltpOutskirtsKwh"
        suffix={ELECTRIC_METRIC_SUFFIX}
      />
      <VFKit.SimpleNumericField
        decimalPlaces={2}
        forceDecimalPlaces
        name="fuelConsumptionWltpCountryRoadsKwh"
        suffix={ELECTRIC_METRIC_SUFFIX}
      />
      <VFKit.SimpleNumericField
        decimalPlaces={2}
        forceDecimalPlaces
        name="fuelConsumptionWltpHighwayKwh"
        suffix={ELECTRIC_METRIC_SUFFIX}
      />
    </>
  );
}
